<div class="mobile-search-comp" (click)="bodyClick($event)">

    <div class="search-bar rounded">
        <div class="container">
            <div class="input-group bg-white rounded">
                <input style="border: none;" type="text" [(ngModel)]="search" (keyup.enter)="doSearch()"
                    placeholder="Search ..." aria-label="Search ..." aria-describedby="form-search"
                    class="font-size-16 form-control">
                <div class="input-group-append px-5 hand" (click)="doSearch()">
                    <!--<img loading="lazy" src="assets/img/icons/icn-nav-arrow-right.svg" />-->
                    <i class="material-symbols-outlined">search</i>
                </div>
            </div>
        </div>
    </div>

    <div class="search-results" *ngIf="loading && showSearch">
        <div class="container">
            <p class="font-size-16 pt-3">One moment please</p>
        </div>
    </div>

    <div class="search-results" *ngIf="(pageResults.length > 0 || instituteResults.length > 0) && showSearch">
        <div class="container">
            <ng-container *ngIf="!error">
                <div class="top-right-close">
                    <i (click)="toggleSearch()" class="fa fa-times hand"></i>
                </div>
                <br>
                <br>
                <br>
                <div class="divider"></div>

                <div class="h4 mt-10 mb-5" *ngIf="pageResults.length > 0">Pages:</div>
                
                <ng-container *ngFor="let page of pageResults">
                    <ng-container *ngIf="page?.parent">
                        <p><a [routerLink]="page?.parent?.slug + '/' + page?.slug" (click)="toggleSearch()">{{page?.title}}</a></p>    
                    </ng-container>
                    <ng-container *ngIf="!page?.parent">
                        <p><a [routerLink]="page.slug" (click)="toggleSearch()">{{page.title}}</a></p>
                    </ng-container>
                </ng-container>
                
                <div class="h4 mt-10 mb-5" *ngIf="instituteResults.length > 0">Courses:</div>
                
                <ng-container *ngFor="let institute of instituteResults">
                    <p><a [routerLink]="'/courses/'+institute?.slug"
                            (click)="toggleSearch()">{{institute?.short_title}}</a>
                    </p>
                </ng-container>

                <br>
                <br>
                <br>
            </ng-container>
        </div>
    </div>
    <div class="no-results" *ngIf="error && showSearch">
        <div class="alert alert-danger max-1">
            No results available for this search.
        </div>
    </div>

</div>